import Vue from 'vue';
import axios from 'axios';
import Qs from 'qs';
import VueAxios from 'vue-axios';
import Router from '../router/index';
import { Message, Loading } from 'element-ui';
import { baseUrl } from '@/http/baseUrl';

Vue.use(VueAxios, axios);
axios.defaults.baseURL = baseUrl;
axios.defaults.withCredentials = true;
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8';
axios.defaults.timeout = 30000;
axios.defaults.transformRequest = function (data, headers) {
  if (headers['Content-Type'] !== 'application/json;charset=UTF-8') {
    if (headers['Content-Type'] === 'multipart/form-data') {
      return data;
    } else {
      return Qs.stringify(data);
    }
  } else {
    return JSON.stringify(data);
  }
};
// 请求响应计数器
let requestNum = 0;
let responseNum = 0;
let loadingInstance;
Vue.nextTick(() => { // 解决Loading非全局单例的问题
  loadingInstance = Loading.service({
    target: document.getElementById('frameContent')
  });
  setTimeout(() => {
    loadingInstance.visible = false;
  }, 100);
});
axios.interceptors.request.use(function (config) {
  config.headers['bs'] = sessionStorage.getItem('bs') || '';
  requestNum++;
  loadingInstance.visible = true;
  return config;
}, function (error) {
  console.log('请求出错了！');
  return Promise.reject(error);
});
axios.interceptors.response.use(function (response) {
  responseNum++;
  if (responseNum === requestNum) {
    Vue.nextTick(() => {
      loadingInstance.visible = false;
    });
  };
  if (response.data.errorCode === 40000) {
    sessionStorage.clear();
    Router.replace({name: 'login'});
  }
  return response;
}, function (error) {
  console.log(error);
  responseNum++;
  if (responseNum === requestNum) {
    Vue.nextTick(() => {
      loadingInstance.visible = false;
    });
  };
  if (error.response && error.response.status) {
    if (error.response.status === 401) {
      Message.error({
        message: '用户名或密码错误！'
      });
    };
    if (error.response.status === 403) {
      Router.replace({name: 'login'});
      Message.info({
        message: '请登录！'
      });
    };
    if (error.response.status === 500) {
      Message.error({
        message: '服务器出错了！'
      });
    };
  }
  return Promise.reject(error);
});



// WEBPACK FOOTER //
// ./src/http/http.js